/** Session storage keys shared by the API layer (GraphQL requests) and the SDK manager (Showcase `auth`). */
export const MATTERPORT_TOKEN_STORAGE_KEY = 'matterport-token';
export const MATTERPORT_TOKEN_EXPIRES_AT_STORAGE_KEY =
  'matterport-token-expires-at';
export const MATTERPORT_CODE_STORAGE_KEY = 'matterport-code';

/**
 * Stores the Matterport access token together with its expiry.
 * @param expiresIn seconds until the token stops being valid; omitted when the caller does not know it
 */
export function storeMatterportToken(token: string, expiresIn?: number): void {
  sessionStorage.setItem(MATTERPORT_TOKEN_STORAGE_KEY, token);
  if (expiresIn === undefined || !Number.isFinite(expiresIn)) {
    sessionStorage.removeItem(MATTERPORT_TOKEN_EXPIRES_AT_STORAGE_KEY);
    return;
  }
  sessionStorage.setItem(
    MATTERPORT_TOKEN_EXPIRES_AT_STORAGE_KEY,
    String(Date.now() + expiresIn * 1000)
  );
}

export function readMatterportToken(): string | null {
  return sessionStorage.getItem(MATTERPORT_TOKEN_STORAGE_KEY);
}

/** Seconds left until the stored token expires, `undefined` when the expiry is unknown. */
export function readMatterportTokenExpiresIn(): number | undefined {
  const expiresAt = Number(
    sessionStorage.getItem(MATTERPORT_TOKEN_EXPIRES_AT_STORAGE_KEY)
  );
  if (!expiresAt) return undefined;
  return Math.max(0, Math.floor((expiresAt - Date.now()) / 1000));
}

export function clearMatterportToken(): void {
  sessionStorage.removeItem(MATTERPORT_TOKEN_STORAGE_KEY);
  sessionStorage.removeItem(MATTERPORT_TOKEN_EXPIRES_AT_STORAGE_KEY);
  sessionStorage.removeItem(MATTERPORT_CODE_STORAGE_KEY);
}
